
import { defineComponent } from "vue";
import MdInputMixin from "./MdInputMixin";
import { uuid } from "@/utils/MdUuid";

export default defineComponent({
  name: "MdInputField",
  mixins: [MdInputMixin],
  props: {
    id: {
      type: String,
      default: () => uuid("input-field"),
    },
  },
});
